import request from '../../utils/request'

export default {
  getAll: data => request({
    url: '/api/services/app/socialSecurityAssign/GetAll',
    method: 'get',
    params: data
  }),
  get: data => request({
    url: '/api/services/app/socialSecurityAssign/Get',
    method: 'get',
    params: data
  }),
  getForEdit: data => request({
     url: '/api/services/app/socialSecurityAssign/GetForEdit',
     method: 'get',
     params: data
  }),
  create: data => request({
    url: '/api/services/app/socialSecurityAssign/Create',
    method: 'post',
    data: data
  }),
  update: data => request({
    url: '/api/services/app/socialSecurityAssign/Update',
    method: 'put',
    data: data
  }),
  delete: function(data) {
    return request({
      url: '/api/services/app/socialSecurityAssign/delete',
      method: 'delete',
      params: data
    })
  }
}
